import script from "./LoginAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginAdmin.vue?vue&type=script&setup=true&lang=js"

import "./LoginAdmin.vue?vue&type=style&index=0&id=4715fae4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4715fae4"]])

export default __exports__